import { render } from "./video-student-impact.vue?vue&type=template&id=055d7ecc&ts=true"
import script from "./video-student-impact.ts?vue&type=script&lang=ts&external"
export * from "./video-student-impact.ts?vue&type=script&lang=ts&external"

import "./video-student-impact.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__